// Utility functions for React components
import { formatLocalDate, formatLocalCurrency } from './format-locale';

export const formatDate = (date: Date | string): string => formatLocalDate(date) ?? '—';

export const formatCurrency = (amount: number): string => formatLocalCurrency(amount);

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: NodeJS.Timeout;

  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

// Export locale-aware formatting utilities
export { formatLocalDate, formatLocalDateTime, formatLocalCurrency, getLocale, formatDateByPattern, localToUtcIso, formatDateByPrefs, formatDateTimeByPrefs } from './format-locale';

// Export case transformation utilities
export { toCamelCase } from './caseTransform';

// Export CSV utilities
export { convertToCsv, downloadCsv, type CsvColumn } from './csv-export';

// Component registration moved to src/react/component-registry.ts (co-located with web-components)
export {
  autoRegisterComponents,
  getDiscoveredComponents,
  type ComponentRegistryConfig,
} from '../component-registry';
